/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import Filters from './Filters';
import DateSelector from 'components/Screening/filters/DateSelector';
import format from 'date-fns/format';
import { Modal } from '@mui/material';

interface IFilterProps {
  cardTab: string;
  setCardTab: React.Dispatch<React.SetStateAction<string>>;
  handleAdvancedSearch: any;
  userHasMonitor?: boolean;
  selectedOptsType: string[];
  setSelectedOptsType: any;
  selectedOptsFreq: string[];
  setSelectedOptsFreq: any;
  selectedOptsStatus: string[];
  setSelectedOptsStatus: any;
}

const SearchFilterComponent: React.FC<IFilterProps> = ({ cardTab, setCardTab, handleAdvancedSearch, userHasMonitor, selectedOptsType, setSelectedOptsType, selectedOptsFreq, setSelectedOptsFreq, selectedOptsStatus, setSelectedOptsStatus }) => {
  const [ isDropdownOpen, setIsDropdownOpen ] = useState(false);
  const [ openDate, setOpenDate ] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleDateChange = (newValue: any) => {
    const arr: any = [ ...newValue ];
    if (newValue !== null) {
      arr.forEach((dt: any, index: number) => {
        if (dt !== null) {
          const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
          const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');
          arr[index] = formatted_dt;
        }
      });
    }
  };


  return (
    <>
      <div className={`tabs-filters ${!userHasMonitor ? 'os-iframe-blur' : ''}`}>
        <div className='tabs-filters-input-dropdown'>
          <div>
            <div className='input-icon-container'>
              <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                <path id='Icon' d='M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
            </div>
            <input className='tabs-filters-input' placeholder='Search tickets' onChange={(e) => handleAdvancedSearch(e.target.value)} />
          </div>
        </div>
        <div className='tabs-filters-action'>
          <div className='tabs-filters-action-btn-grp'>
            <div className={`${cardTab === 'List' ? 'tabs-filters-action-btn-grp-left-select' : 'tabs-filters-action-btn-grp-left'}`} onClick={() => {
              setCardTab('List');
            }}>
              <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                <path d='M17.5 9.99984L7.5 9.99984M17.5 4.99984L7.5 4.99984M17.5 14.9998L7.5 14.9998M4.16667 9.99984C4.16667 10.4601 3.79357 10.8332 3.33333 10.8332C2.8731 10.8332 2.5 10.4601 2.5 9.99984C2.5 9.5396 2.8731 9.1665 3.33333 9.1665C3.79357 9.1665 4.16667 9.5396 4.16667 9.99984ZM4.16667 4.99984C4.16667 5.46007 3.79357 5.83317 3.33333 5.83317C2.8731 5.83317 2.5 5.46007 2.5 4.99984C2.5 4.5396 2.8731 4.1665 3.33333 4.1665C3.79357 4.1665 4.16667 4.5396 4.16667 4.99984ZM4.16667 14.9998C4.16667 15.4601 3.79357 15.8332 3.33333 15.8332C2.8731 15.8332 2.5 15.4601 2.5 14.9998C2.5 14.5396 2.8731 14.1665 3.33333 14.1665C3.79357 14.1665 4.16667 14.5396 4.16667 14.9998Z' stroke='#EFF1F6' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
              <div className='tabs-filters-action-date-picker-btn-text'>
              List
              </div>
            </div>
            <div className={`${cardTab === 'Card' ? 'tabs-filters-action-btn-grp-right-select' : 'tabs-filters-action-btn-grp-right'}`} onClick={() => {
              setCardTab('Card');
            }}>
              <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
                <path d='M2.5 6.5C2.5 5.09987 2.5 4.3998 2.77248 3.86502C3.01217 3.39462 3.39462 3.01217 3.86502 2.77248C4.3998 2.5 5.09987 2.5 6.5 2.5H13.5C14.9001 2.5 15.6002 2.5 16.135 2.77248C16.6054 3.01217 16.9878 3.39462 17.2275 3.86502C17.5 4.3998 17.5 5.09987 17.5 6.5V13.5C17.5 14.9001 17.5 15.6002 17.2275 16.135C16.9878 16.6054 16.6054 16.9878 16.135 17.2275C15.6002 17.5 14.9001 17.5 13.5 17.5H6.5C5.09987 17.5 4.3998 17.5 3.86502 17.2275C3.39462 16.9878 3.01217 16.6054 2.77248 16.135C2.5 15.6002 2.5 14.9001 2.5 13.5V6.5Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M6.66667 8C6.66667 7.53329 6.66667 7.29993 6.75749 7.12167C6.83739 6.96487 6.96487 6.83739 7.12167 6.75749C7.29993 6.66667 7.53329 6.66667 8 6.66667H12C12.4667 6.66667 12.7001 6.66667 12.8783 6.75749C13.0351 6.83739 13.1626 6.96487 13.2425 7.12167C13.3333 7.29993 13.3333 7.53329 13.3333 8V12C13.3333 12.4667 13.3333 12.7001 13.2425 12.8783C13.1626 13.0351 13.0351 13.1626 12.8783 13.2425C12.7001 13.3333 12.4667 13.3333 12 13.3333H8C7.53329 13.3333 7.29993 13.3333 7.12167 13.2425C6.96487 13.1626 6.83739 13.0351 6.75749 12.8783C6.66667 12.7001 6.66667 12.4667 6.66667 12V8Z' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
              <div className='tabs-filters-action-date-picker-btn-text'>
              Cards
              </div>
            </div>
          </div>
          <div className='tabs-filters-action-filters' onClick={toggleDropdown}>
            <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
              <path d='M5 10H15M2.5 5H17.5M7.5 15H12.5' stroke='#BDBEC1' strokeWidth='1.66667' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
            <div className='tabs-filters-action-date-picker-btn-text'>
            Filters {(selectedOptsType.length + selectedOptsFreq.length + selectedOptsStatus.length)}
            </div>
          </div>
        </div>
        {isDropdownOpen && (
          <Filters selectedOptsType={selectedOptsType} setSelectedOptsType={setSelectedOptsType} selectedOptsFreq={selectedOptsFreq} setSelectedOptsFreq={setSelectedOptsFreq} selectedOptsStatus={selectedOptsStatus} setSelectedOptsStatus={setSelectedOptsStatus} />
        )}
      </div>
    </>
  );
};

export default SearchFilterComponent;
